const component = require('../component/component');

const pagination = Object.assign({}, component, {
    currPage: 1,
    noItems: 0,
    noPages: 0,
    listId: '',
    subelements: {
        pagesList: null,
        pagingInfo: null
    },

    init: function () {
        component.init.call(this);

        this.listId = this.extraAttributes.filterListId;

        document.addEventListener('zitClear', (e) => {
            if (e.listId === this.listId) {
                this.clear();
            }
        });

        document.addEventListener('zitLoaded', (e) => {
            if (e.detail.listId === this.listId) {
                this.build(e.detail.response);
            }
        });
    },

    clear: function () {
        this.element.innerHTML = '';
    },

    build: async function (response) {
        if (this.hm.app.appInitPromise !== false) {
            await this.hm.app.appInitPromise;
        }

        if (typeof response.paging != typeof undefined) {
            let _paging = response.paging;

            this.noItems = parseInt(_paging.noItems);

            let countHTML = '';

            // Tier-resolved "muted" text class for the count emphasis spans
            // (m8: text-gray-600, zb5: text-secondary) — no literal token in base.
            let mutedText = this.hm.app.cssClass('mutedText');

            if (typeof response.appliedFilters.noPP !== typeof undefined) {
                countHTML += response.appliedFilters.noPP.title + ': <strong class="' + mutedText + '">' + response.appliedFilters.noPP.value + '</strong> / ';
            }

            if (typeof response.appliedFilters.countAccuracy !== typeof undefined) {
                countHTML += response.appliedFilters.countAccuracy.title + ': <strong class="' + mutedText + '">' + response.appliedFilters.countAccuracy.value + '</strong> / ';
            }

            if (this.noItems > 0) {
                countHTML += this.hm.app.utext('showingItems') + ' <strong class="' + mutedText + '">' + _paging.first + ' ' + this.hm.app.text('to') + ' ' + _paging.last + ' ' + this.hm.app.text('of') + ' ' + (_paging.countAccuracy == 'aproximate' ? '~' : '') + _paging.noItems + ' ' + this.hm.app.text('totalItems') + '</strong> / ';
            } else if (this.noItems == 0) {
                countHTML += this.hm.app.utext('noItemsFound') + ' / ';
            } else {
                countHTML += this.hm.app.utext('noDisplayedRows') + ': <strong class="' + mutedText + '">' + response.items.length + '</strong> / ';
            }

            this.subelements.pagingInfo.innerHTML = countHTML.substring(0, countHTML.length - 3);

            this.subelements.pagesList.innerHTML = '';

            this.currPage = _paging.page;

            if (_paging.noPages > 1) {
                // Tier-resolved activation state classes (m8/zb5 both single-token
                // today; split+spread keeps multi-token future tiers working).
                let disabledClass = this.hm.behaviors.activation.stateClass('disabled');
                let activeClass = this.hm.behaviors.activation.stateClass('active');

                let firstLi = this.newLi('first');

                if (_paging.page == 1) {
                    firstLi.classList.add(...disabledClass.split(' '));
                } else {
                    firstLi.querySelector('a').onclick = (e) => {
                        e.preventDefault();
                        this.goToPage(1);
                        return false;
                    };
                }

                this.subelements.pagesList.appendChild(firstLi);

                let prevLi = this.newLi('previous');

                if (_paging.prev <= 1 || _paging.prev === false) {
                    prevLi.classList.add(...disabledClass.split(' '));
                } else {
                    prevLi.querySelector('a').onclick = (e) => {
                        e.preventDefault();
                        this.goToPage(_paging.prev);
                        return false;
                    };
                }

                this.subelements.pagesList.appendChild(prevLi);

                for (let pag = 0; pag < _paging.pages.length; pag++) {
                    let pagLi = this.newLi('pageNo');
                    pagLi.querySelector('a').innerHTML = _paging.pages[pag];

                    if (_paging.page == _paging.pages[pag]) {
                        pagLi.classList.add(...activeClass.split(' '));
                        pagLi.querySelector('a').onclick = (e) => {
                            e.preventDefault();
                            return false;
                        };
                    } else {
                        pagLi.querySelector('a').onclick = (e) => {
                            e.preventDefault();
                            this.goToPage(_paging.pages[pag]);
                            return false;
                        };
                    }
                    this.subelements.pagesList.appendChild(pagLi);
                }

                let nextLi = this.newLi('next');

                if (_paging.next && _paging.next > _paging.noPages && _paging.page != _paging.next) {
                    nextLi.classList.add(...disabledClass.split(' '));
                } else {
                    nextLi.querySelector('a').onclick = (e) => {
                        e.preventDefault();
                        this.goToPage(_paging.next);
                        return false;
                    };
                }

                this.subelements.pagesList.appendChild(nextLi);

                let lastLi = this.newLi('last');

                if (_paging.page == _paging.noPages) {
                    lastLi.classList.add(...disabledClass.split(' '));
                } else {
                    lastLi.querySelector('a').onclick = (e) => {
                        e.preventDefault();
                        this.goToPage(_paging.noPages);
                        return false;
                    };
                }

                this.subelements.pagesList.appendChild(lastLi);
            }
        }
    },

    // Maps the structural pagination index to its tier-specific <li> modifier
    // cssClassesMap key. zb5 resolves these to "" (no modifier); m8 resolves
    // them to first/previous/next/last. 'pageNo' has no modifier (base only).
    pageItemModifierKey: {
        first: 'pageItemFirst',
        previous: 'pageItemPrevious',
        next: 'pageItemNext',
        last: 'pageItemLast'
    },

    newLi: function (index) {
        let newLi = document.createElement('li');
        newLi.innerHTML = this.getTemplate(index);

        // Base pagination-item class, resolved per-tier via cssClassesMap
        // (m8/zb5: "page-item"). Split+spread for multi-token future tiers.
        let pageItemClass = this.hm.app.cssClass('pageItem');
        if (pageItemClass !== '') {
            newLi.classList.add(...pageItemClass.split(' '));
        }

        // first/previous/next/last get an extra tier-specific modifier class.
        if (index !== 'pageNo') {
            let modifierClass = this.hm.app.cssClass(this.pageItemModifierKey[index]);
            if (modifierClass !== '') {
                newLi.classList.add(...modifierClass.split(' '));
            }
        }

        return newLi;
    },

    goToPage: function (pageNo) {
        this.currPage = pageNo;
        this.hm.app.components[this.listId].loadItems(this);
    },

    getValue: function () {
        return this.currPage;
    }
});

module.exports = pagination;